import { TopToolbar, Button, useNavigate } from 'react-admin';
import { Settings as SettingsIcon } from '@mui/icons-material';

/**
 * Custom actions bar for catalog list view
 * Includes button to navigate to Catalog Rules page
 */
export const CatalogListActions = () => {
  const navigate = useNavigate();

  return (
    <TopToolbar>
      <Button
        label="Manage Catalog Rules"
        onClick={() => navigate('/catalog-rules')}
        startIcon={<SettingsIcon />}
      />
    </TopToolbar>
  );
};
